/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import consentdocumentupload from "../SiteUserDashboard/consentdocumentupload.vue"; 
import customModal from "../customModal/customModal.vue";
import ReconsentCampaignmodal from "./ReconsentCampaignmodal.vue";
import ICFVideos from "./ICFVideos.vue";
 
export default {
    name: "icfListing",
    components: {
      VPagination,consentdocumentupload,customModal, ReconsentCampaignmodal, ICFVideos
    },
    data() {
        return {
            showLoading: true,
            icfList: [],
            showSidePopup: [],
            index: null,
            selectedConsentRecordId: null,
            baseurl: process.env.VUE_APP_Service_URL,
            formName: "",
            version: "",
            selectedICF: null,
            language: "",
            activeSortColumn: "",
            token: "",
            studyId: "",
            pageNumber: 1,
            currentPageNumber: 1,
            SortOrder: 0,
            SortProperty: "",
            showreconsentcampaignpopup: false,
            currentPage: 1,
            totalItems: 0,
            totalPages: 0,
            pageSize: 10,
            documentUploadpopup: false,
            showVideosPopup: false,
            selectedVideoIcfId: null,
            selectedVideoIcfName: "",
            selectedVideoIcfVersion: "",
        };
    },

     computed:{
        rollsprivilages() {
        return store.getters.getRolesprivilegeData || [];
      }
      },
      
    async mounted() {
        this.token = store.getters.getIdToken;
        this.studyId = store.getters.getStudyIs;
        await this.getICFForms();
    },
    methods: {
        // formatDate(dateString) {
        //     if (!dateString) return '-';
        //     const date = new Date(dateString);
        //     return date.toLocaleDateString();
        // },
        formatDate(dateString) {
    if (!dateString) return '-';

    const date = dateString.split("T")[0];

    const [year, month, day] = date.split("-");

    return `${day}/${month}/${year}`;
},
        
        async getICFForms() {
            this.showLoading = true;
            try {
                let url = `${this.baseurl}/management/patientdocument/listicfformsbystudy?studyId=${this.studyId}`;
                
                if (this.SortProperty) {
                    url += `&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`;
                }
                
                if (this.formName) {
                    url += `&FormName=${encodeURIComponent(this.formName)}`;
                }
                if (this.version) {
                    url += `&Version=${encodeURIComponent(this.version)}`;
                }
                if (this.language) {
                    url += `&Language=${encodeURIComponent(this.language)}`;
                }
                
                const response = await axios.get(url, {
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "Content-Type": "application/json",
                    },
                });
                
                console.log("ICF forms are", response.data);
                
                if (response.data && response.data.results) {
                    let filteredData = [...response.data.results];
                    
                    // Apply sorting
                    if (this.SortProperty && this.SortProperty !== 'index') {
                        filteredData.sort((a, b) => {
                            let aVal, bVal;
                            
                            if (this.SortProperty === 'uploadedBy') {
                                aVal = a.uploadedBy?.name || a.uploadedBy?.userId || '';
                                bVal = b.uploadedBy?.name || b.uploadedBy?.userId || '';
                            } else {
                                aVal = a[this.SortProperty];
                                bVal = b[this.SortProperty];
                            }
                            
                            if (aVal < bVal) return this.SortOrder === 0 ? -1 : 1;
                            if (aVal > bVal) return this.SortOrder === 0 ? 1 : -1;
                            return 0;
                        });
                    }
                    
                    this.totalItems = response.data.totalCount || filteredData.length;
                    this.totalPages = Math.ceil(this.totalItems / this.pageSize);
                    const start = (this.currentPage - 1) * this.pageSize;
                    const end = start + this.pageSize;
                    this.icfList = filteredData.slice(start, end);
                    this.showSidePopup = new Array(this.icfList.length).fill(false);
                } else {
                    this.icfList = [];
                    this.totalItems = 0;
                    this.totalPages = 0;
                }
            } catch (err) {
                console.log("error..", err);
                this.icfList = [];
            } finally {
                this.showLoading = false;
            }
        },
        
        async createICFForm(id) {
            this.documentUploadpopup = true;
           
        },
        
        async deleteICFForm(id) {
            if (confirm(this.$t('navigations.are you sure you want to delete this ICF form?'))) {
                try {
                    await axios.delete(
                        `${this.baseurl}/management/patientdocument/deleteicfform?Id=${id}`,
                        {
                            headers: {
                                Authorization: "Bearer " + this.token,
                                "Content-Type": "application/json",
                            },
                        }
                    );
                    alert(this.$t("navigations.icf form deleted successfully"));
                    await this.getICFForms();
                } catch (err) {
                    console.log(err);
                    alert(err.response?.data?.detail || "Delete failed");
                }
            }
        },
        
        async SearchButtonClicked() {
            this.currentPage = 1;
            await this.getICFForms();
        },
        getICFDocumentId(icf) {
            return (
                icf?.formId ||
                icf?.documentReferenceId ||
                icf?.documentId ||
                icf?.documentID ||
                icf?.id ||
                ""
            );
        },

        getICFDocumentVersion(icf) {
            return (
                icf?.versionNumber ||
                icf?.latestVersion ||
                icf?.version ||
                icf?.versionId ||
                0
            );
        },

        async viewICFForm(icf) {
            const documentId = this.getICFDocumentId(icf);
            const version = this.getICFDocumentVersion(icf);

            if (!documentId) {
                alert("Document id is missing.");
                return;
            }

            this.$router.push(`/documentview/${documentId}/${version}`);
        },
        SortSelected(property, columnId) {
            if (property === 'index') {
                // Handle index sorting separately
                if (this.SortProperty === property) {
                    this.SortOrder = this.SortOrder === 0 ? 1 : 0;
                } else {
                    this.SortProperty = property;
                    this.SortOrder = 0;
                }
            } else {
                if (this.SortProperty === property) {
                    this.SortOrder = this.SortOrder === 0 ? 1 : 0;
                } else {
                    this.SortProperty = property;
                    this.SortOrder = 0;
                }
            }
            this.activeSortColumn = property;
            console.log(`Sorting by ${property}, order: ${this.SortOrder}`);
            this.currentPage = 1;
            this.getICFForms();
        },
        
        loadPage(page) {
            this.currentPage = page;
            this.getICFForms();
        },
         handleCloseDocumentUpload() {
        this.documentUploadpopup = false;
    },
        handleDocumentUploaded() {
        // Refresh the list after successful upload
        this.getICFForms();
    },
openReconsentModal(icf, index) {
    this.selectedConsentRecordId = icf.consentRecordId || icf.id;

    this.selectedICF = {
        icfId: icf.id || icf.consentFormId,
        icfDocumentID: icf.formId, 
        icfName: icf.formName,
        version: icf.versionNumber
    };

    this.showreconsentcampaignpopup = true;
    this.showSidePopup[index] = false;
},
togglePopup(index) {

  // Close all popups first
  this.showSidePopup = this.showSidePopup.map(() => false);

  // Open selected popup
  this.showSidePopup[index] = true;

},
openvideos(icfId, icfName, icfVersion) {
    this.selectedVideoIcfId = icfId;
    this.selectedVideoIcfName = icfName;
    this.selectedVideoIcfVersion = icfVersion;
    this.showVideosPopup = true;
},


    }
};
